import { dashBoardConstants } from '../../_constants/dashBoard.constants';

const initialState = { edit_asessement_loading : true, edit_asessement: '', edit_asessement_error: false};

export function editAsessmentReducer(state = initialState, action) {
    switch (action.type) {
        case dashBoardConstants.REQUEST_EDTI_ASSESSMENT:
        return {
            edit_asessement_loading: true,
            edit_asessement: '',
            edit_asessement_error: false
        };
      case dashBoardConstants.RECIEVE_EDTI_ASSESSMENT:
        return {
            edit_asessement_loading: false,
            edit_asessement: action.edit_asessement,
            edit_asessement_error: false
        };
      case dashBoardConstants.ERROR_EDTI_ASSESSMENT:
        return { 
            edit_asessement_loading: false,
            edit_asessement: '',
            edit_asessement_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/dashBoard/editAssessment.reducer.js